// extracted by mini-css-extract-plugin
export default {"container":"About_container__53crO","imgContainer":"About_imgContainer__-+fQq","img":"About_img__szuVS","text":"About_text__NCoHq"};